/** Train-specific error with code */
export class TrainError extends Error {
    constructor(message, code, cause) {
        super(message);
        this.code = code;
        this.cause = cause;
        this.name = 'TrainError';
    }
}
export var TrainErrorCode;
(function (TrainErrorCode) {
    TrainErrorCode["ApiError"] = "API_ERROR";
    TrainErrorCode["NetworkError"] = "NETWORK_ERROR";
    TrainErrorCode["WalletNotConnected"] = "WALLET_NOT_CONNECTED";
    TrainErrorCode["NoAdapterRegistered"] = "NO_ADAPTER_REGISTERED";
    TrainErrorCode["LockFailed"] = "LOCK_FAILED";
    TrainErrorCode["RevealFailed"] = "REVEAL_FAILED";
    TrainErrorCode["RefundFailed"] = "REFUND_FAILED";
    TrainErrorCode["ClaimFailed"] = "CLAIM_FAILED";
    TrainErrorCode["RecoverFailed"] = "RECOVER_FAILED";
    TrainErrorCode["VerificationFailed"] = "VERIFICATION_FAILED";
    TrainErrorCode["TimelockExpired"] = "TIMELOCK_EXPIRED";
    TrainErrorCode["SecretDerivationFailed"] = "SECRET_DERIVATION_FAILED";
    TrainErrorCode["OrderFailed"] = "ORDER_FAILED";
    TrainErrorCode["UserLockTransactionFailed"] = "USER_LOCK_TRANSACTION_FAILED";
})(TrainErrorCode || (TrainErrorCode = {}));
